import moment from "moment";

import CONSTANTS from "constants/constant";

const formatLastUpdate = (value: string) => {
	if (!value) return;

	const parsedDate = moment(value);
	const formatDate = parsedDate.format(CONSTANTS.LAST_UPDATE_FORMAT);

	return formatDate;
};

export default formatLastUpdate;
